/**
 * Storage keys for Reports domain
 *
 * All keys follow the namespace format: parrot:reports:{key}
 */
export const REPORT_STORAGE_KEYS = {
  APPLIED_FILTERS: 'parrot:reports:applied-filters',
  FILTERS_METADATA: 'parrot:reports:filters-metadata',
} as const;

/**
 * Metadata stored alongside filters to track store and report path context
 * Used to detect when filters should be cleared due to context changes
 */
export type FiltersMetadata = {
  storeUuid: string;
  reportPath: string;
};
